<main class="app-wrapper">
    <div class="">
        <router-outlet></router-outlet>
    </div>
</main>